import {
  MolsonButton,
  MolsonDialog,
  MolsonDialogActions,
  MolsonDialogHeader
} from '@components/reusable'
import { useTranslation } from 'react-i18next'

export type DeleteDialogProps = {
  cancelText?: string
  deleteText?: string
  onClose: () => void
  onDelete?: () => 0 | Promise<void> | null | undefined | void
  open: boolean
  subTitle: string
  title: string
  deletePending?: boolean
}

export const DeleteDialog = ({
  cancelText,
  deleteText,
  onClose,
  onDelete,
  open,
  subTitle,
  title,
  deletePending
}: DeleteDialogProps) => {
  const { t } = useTranslation()
  const handleDelete = async () => {
    await onDelete?.()
    onClose()
  }

  const cancelTextValue = cancelText ?? t('common.cancel')
  const deleteTextValue = deleteText ?? t('common.delete')

  return (
    <MolsonDialog fullWidth={true} maxWidth="sm" onClose={onClose} open={open}>
      <MolsonDialogHeader
        displayDivider={false}
        subTitle={subTitle}
        title={title}
      />

      <MolsonDialogActions displayDivider={false}>
        <MolsonButton color="secondary" onClick={onClose} variant="outlined">
          {cancelTextValue}
        </MolsonButton>
        <MolsonButton
          color="error"
          onClick={handleDelete}
          variant="contained"
          loading={deletePending}
        >
          {deleteTextValue}
        </MolsonButton>
      </MolsonDialogActions>
    </MolsonDialog>
  )
}
